import { useQuery } from '@tanstack/react-query';
import {
  IBussinessAccountBody,
  IGetBussinessAccounts,
} from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';

export const getBusinessAccount = async (params?: IBussinessAccountBody) => {
  const res = await apiManager.get<IGetBussinessAccounts>(
    "/admin/business-accounts/all",
    params
  );
  return res;
};

export const useGetBusinessAccounts = (params?: IBussinessAccountBody) =>
  useQuery({
    queryKey: ["get_business_accounts", params],
    queryFn: async (): Promise<IGetBussinessAccounts> => {
      const res = await apiClient.get("/admin/business-accounts/all", { params });
      return res.data;
    },
  });